import React from "react";
import Footer from "../Footer/Footer";
import Helmet from 'react-helmet';
import Navbar from "../Navbar/Navbar";
import { graphql, useStaticQuery } from 'gatsby';
import "./Layout.css";

function Layout({ extraTitle = '', children }) {
  const { contact: { siteMetadata: { title } } } = useStaticQuery(graphql`
   query SiteMetaData {
    contact: site(siteMetadata: {}) {
      siteMetadata {
        title
      }
    }
  }
  `);
  return <div className="site-container">
    <Helmet title={extraTitle + title} />
    <Navbar />
    {children}
    <Footer />
  </div>
}

export default Layout;